import { datadogLogs } from '@datadog/browser-logs';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';

import { deleteSuggestedMessage } from 'services/suggestedMessages';

import { DeleteScheduledMessageProps } from './types';

const DeleteScheduledMessage: React.FC<DeleteScheduledMessageProps> = ({
  id,
  isOpen,
  onClose,
  onDelete,
}) => {
  const intl = useIntl();
  const queryClient = useQueryClient();

  const handleClose = () => {
    onClose();
  };

  const { mutate } = useMutation({
    mutationKey: ['deleteScheduledMessage'],
    mutationFn: deleteSuggestedMessage,
    onSuccess: () => {
      onDelete();
      handleClose();
    },
    onError(error, variables, context) {
      datadogLogs.logger.error('Error deleting scheduled message', {
        error,
        variables,
        context,
      });
    },
  });

  const handleDeleteScheduledMessage = () => {
    mutate(id);
    queryClient.refetchQueries(['getSpecialistChatUsers']);
  };

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle>
        {intl.formatMessage({ id: 'MESSAGETIPS.DELETEMODAL.TITLE' })}
      </DialogTitle>
      <DialogContent>
        {intl.formatMessage({ id: 'MESSAGETIPS.DELETEMODAL.SUBTITLE' })}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleDeleteScheduledMessage}>
          {intl.formatMessage({ id: 'MESSAGETIPS.DELETEMODAL.CANCELBUTTON' })}
        </Button>
        <Button onClick={handleClose}>
          {intl.formatMessage({ id: 'MESSAGETIPS.EDITSCHEDULE.BACKBUTTON' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { DeleteScheduledMessage };
